export enum ServerOperationResult {
  Success,
  Failure,
}
